import React from 'react';
import { Spinner } from 'baseui/spinner';
import { useStyletron } from 'baseui';

const Loader: React.FC<{}> = () => {
	const [css] = useStyletron();

	return (
		<div
			className={css({
				position: 'absolute',
				left: 0,
				right: 0,
				top: 0,
				bottom: 0,
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				background: '#44414124',
				zIndex: 10000
			})}>
			<Spinner />
		</div>
	);
};

export default Loader;
